import { render } from "./RewardsView.vue?vue&type=template&id=a08140f2"
import script from "./RewardsView.vue?vue&type=script&lang=js"
export * from "./RewardsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__